import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../../zustand/userStore";
import {
  assignUser,
  clearAssignUser,
  fetchTeachers,
} from "./redux/teacherSlice";
import { createTeacherUser } from "../../../pages/user/redux/userThunk";

const AssignUser = () => {
  const { teacherData } = useSelector((state) => state.teachers); // get teacherData from redux
  const userData = userStore((state) => state.user);
  const masterData = useSelector((state) => state.masterData);

  const schoolId = masterData?.school_id;

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    // role_id: "",
    contact_number: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();

  // 🔹 Auto-fill username from teacherData
  useEffect(() => {
    if (teacherData) {
      setFormData((prev) => ({
        ...prev,
        username: teacherData.name || "",
      }));
    }
  }, [teacherData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    // const body = {
    //   username: formData.username,
    //   email: formData.email,
    //   password: formData.password,
    //   role_id: formData.role_id,
    //   created_by: userData.id,
    //   teacherId: teacherData.teacher_id,
    // };

    const body = {
      username: teacherData.name || "",
      email: formData.email,
      password: formData.password,
      role_id: 1,
      created_by: userData.id,
      school_name: userData.school_name,
      contact_number: formData.contact_number,
      address: userData.address,
      school_type: "Primary",
      db_name: userData.db_name,
      port: userData.port,
      account_type: userData.account_type,
      teacher_id: teacherData.teacher_id,
      parent_id: userData.admin_id || "",
    };

    console.log("srinu_61", body);
    try {
      await dispatch(createTeacherUser(body)).unwrap();
      dispatch(fetchTeachers(schoolId));
      dispatch(clearAssignUser());
    } catch (error) {
      console.error("User creation failed:", error);
    }
  };

  return (
    <div style={{ padding: "0px", marginTop: "10px" }}>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "16px", rowGap: "12px" }}>
          {/* Username (readonly) */}
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Username</label>
            <input
              type="text"
              name="username"
              className="form-control"
              style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
              value={formData.username}
              readOnly
              disabled
            />
          </div>

          {/* Email */}
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
              placeholder="Enter email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Password */}
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Password</label>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control pe-5"
                style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <span
                className="position-absolute top-50 end-0 translate-middle-y me-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <i
                  className={`fa-solid ${
                    showPassword ? "fa-eye-slash" : "fa-eye"
                  }`}
                  style={{ fontSize: "12px" }}
                ></i>
              </span>
            </div>
          </div>

          {/* Confirm Password */}
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Confirm Password</label>
            <div className="position-relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                className="form-control pe-5"
                style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
                placeholder="Confirm password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <span
                className="position-absolute top-50 end-0 translate-middle-y me-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                <i
                  className={`fa-solid ${
                    showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                  }`}
                  style={{ fontSize: "12px" }}
                ></i>
              </span>
            </div>
          </div>

          {/* Contact Number */}
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Contact Number</label>
            <input
              type="tel"
              name="contact_number"
              className="form-control"
              style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
              placeholder="Enter contact number"
              value={formData.contact_number}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                if (val.length <= 10) {
                  setFormData((prev) => ({ ...prev, contact_number: val }));
                }
              }}
              maxLength={10}
              required
            />
          </div>

          {/* Role (Commented Out) */}
          {/*
          <div>
            <label className="form-label" style={{ fontSize: "13px", marginBottom: "4px" }}>Role</label>
            <select
              name="role_id"
              className="form-select"
              style={{ height: "35px", padding: "0 12px", fontSize: "13px", borderRadius: "5px" }}
              value={formData.role_id}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Select Role
              </option>
              <option value={2}>Admin</option>
              <option value={1}>User</option>
            </select>
          </div>
          */}
        </div>

        {/* Submit Button */}
        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary" style={{ padding: "6px 24px", fontSize: "13px", borderRadius: "5px" }}>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AssignUser;
